export default __webpack_public_path__ + "static/media/logout-icon.3cc78d9b.svg";